// extracted by mini-css-extract-plugin
export default {"button":"SearchButton__button--7CYBM"};